import React, { useState } from 'react';
import { MdShoppingCart } from 'react-icons/md';
import { FaPills, FaMoneyBillWave, FaTruck, FaBoxOpen } from 'react-icons/fa';
import api from '../../../utils/api';
import { api_url } from '../../../config';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ColorRing } from 'react-loader-spinner';
import { hasPermission } from '../../../Redux/permissionSlice';

const ShippedComponent = ({ order, fetchOrder, roles }) => {
    const { id, token, branch_id } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);

    const UpdateOrder = async () => {
        if (!navigator.onLine) {
            toast("You're offline");
            return;
        }

        try {
            setLoading(true);
            await api.put(
                api_url + `/api/v1/retailer/user/${id}/branch/${branch_id}/order/${order.id}`,
                { data: { status: "received" } },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                }
            );
            fetchOrder();
        } catch (error) {
            console.log(error);
            toast("Error updating order");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-4 sm:p-6">
            {/* Header Section */}
            <div className="mb-6">
                <div className="flex items-center gap-3 mb-2">
                    <FaTruck className="text-green-500 text-2xl" />
                    <h2 className="text-xl font-semibold text-gray-800">Package in Transit</h2>
                </div>
                <p className="text-sm text-gray-600">Your order is on its way. Please confirm when received</p>
            </div>

            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4">
                        <MdShoppingCart className="text-green-500 text-3xl" />
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Order Shipped</h3>
                    <p className="text-gray-600 max-w-md">
                        Your package is being delivered. Please confirm receipt once you receive it.
                    </p>
                    <div className="mt-6 flex items-center gap-4 text-sm text-gray-500">
                        <div className="flex items-center gap-2">
                            <FaPills className="text-green-500" />
                            <span>Order Processed</span>
                        </div>
                        <div className="w-8 h-px bg-gray-200"></div>
                        <div className="flex items-center gap-2">
                            <FaMoneyBillWave className="text-green-500" />
                            <span>Payment Sent</span>
                        </div>
                        <div className="w-8 h-px bg-gray-200"></div>
                        <div className="flex items-center gap-2">
                            <FaTruck className="text-green-500" />
                            <span>In Transit</span>
                        </div>
                        <div className="w-8 h-px bg-gray-200"></div>
                        <div className="flex items-center gap-2">
                            <FaBoxOpen className="text-green-500" />
                            <span>Awaiting Delivery</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Action Buttons */}
            {hasPermission(roles, ['orderWriter', 'orderAdmin']) && (
                <div className="flex justify-end mt-6">
                    <button
                        onClick={UpdateOrder}
                        disabled={loading}
                        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                    >
                        {loading ? (
                            <ColorRing
                                height="20"
                                width="20"
                                colors={['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff']}
                            />
                        ) : (
                            <>
                                <FaBoxOpen />
                                Confirm Receipt
                            </>
                        )}
                    </button>
                </div>
            )}
        </div>
    );
}

export default ShippedComponent;
